import { useQuery } from "shared/hooks/useApi";
import { ATTACHMENTS } from "utils/api/graphql/queries/attachments";
import { INSURANCE_PLAN_ATTACHMENTS_TYPES } from "utils/constants";

export const DEFAULT_PLAN_ATTACHMENT_TYPES = Object.values(
  INSURANCE_PLAN_ATTACHMENTS_TYPES,
);

export const planAttachmentsVariables = ({ planId, types, projectId }) => {
  if (!planId) return null;
  const typeList =
    Array.isArray(types) && types.length
      ? types
      : DEFAULT_PLAN_ATTACHMENT_TYPES;
  const planClause = { insurancePlans: { id: planId } };
  const or = [{ AND: [{ project: null }, planClause] }];
  if (projectId) {
    or.unshift({
      AND: [{ project: { id: projectId } }, planClause],
    });
  }
  return {
    isIn: { type: typeList },
    where: { OR: or },
  };
};

export const usePlanAttachments = ({ enabled, planId, types, projectId }) => {
  const variables = planAttachmentsVariables({
    planId,
    types,
    projectId,
  });
  const { data } = useQuery(ATTACHMENTS, {
    variables: variables || { where: { id: "__skip__" } },
    skip: !enabled || !variables,
  });
  const attachments = (data && data.attachments && data.attachments.data) || [];
  return { planAttachments: attachments };
};
